export var dataHooks = {
  buttonThumbnail: function buttonThumbnail(index) {
    return "btn-thumbnail-".concat(index);
  }
};